module.exports = __webpack_public_path__ + "img/light-mud-decal-11.38befc0d.png";